/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCasesV1CaseEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_CASES_V1_CASE_EVENT_ENTITY_NAME = 'ixc.cases.v1.CaseEvent';
export const ixcCasesV1CaseEventEntity = new schema.Entity<IxcCasesV1CaseEvent>(IXC_CASES_V1_CASE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcCasesV1CaseEvent) => `${entity.metadata?.eventId}` });

